
import React, {useState, useEffect} from "react";

import axios from "axios";
import parse from 'html-react-parser';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


axios.defaults.baseURL='https://suvivah.org/suvivah/api/';



function Testimonials() {

    const TestimonialsSlider = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: 2,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1,
            slidesToSlide: 1,
        },
        };

    //   const TestimonialsSlider = {        

    //     superLargeDesktop: {
    //       // the naming can be any, depends on you.
    //       breakpoint: { max: 4000, min: 3000 },
    //       items: 2
    //     },
    //     desktop: {
    //       breakpoint: { max: 3000, min: 1024 },
    //       items: 2
    //     },
    //     tablet: {
    //       breakpoint: { max: 1024, min: 464 },
    //       items: 1
    //     },
    //     mobile: {
    //       breakpoint: { max: 464, min: 0 },
    //       items: 1
    //     }
    //   };

      



    const [testimonials, setTestimonials] = useState([]);
    async function gettestimonials() {
        var resp=await axios.get("/testimonial");
        var data=resp.data;
        setTestimonials(data.testimonial);
        console.log(data.testimonial);
    }
     
    useEffect(() => {
        gettestimonials();
    }, [])

    return(
        <>

<section className="py-5 testimonials-row">
<div className="container">
    <div className="row">
        <div className="col-md-12 text-center">
            <header className="header-text">
                {/* <h2 className="mb-2">What Clients <span>Say</span></h2> */}
                <h2 className="mb-2">
                    People's <span>Opinion</span><br/>
                    (মানুষের <span>মতামত</span>)
                </h2>
                <p className="text-center mb-4"><img src="images/header_graphics.png" alt="" className="img-fluid" /></p>
            </header>
        </div>
    </div>


    <Carousel
            responsive={TestimonialsSlider}
            arrows={true}
            showDots={false}
            autoPlay={true}
            autoPlaySpeed={3000}
            infinite={true}
            keyBoardControl={true}
            pauseOnHover={true}
            draggable={true}
            swipeable={true}
        >
            
            {testimonials.map((e) => {
                const initials = e.testimonial_name
                    ?.trim()
                    .split(" ")
                    .filter(Boolean)
                    .map((word) => word[0].toUpperCase())
                    .slice(0, 2)
                    .join("");

                return (
                    <div key={e.testimonial_id} className="px-2 h-100">
                    <div className="card bg-card-warning border h-100 border-danger rounded-5">
                    <div className="card-body d-flex flex-column">
                    {/* <div className="testimonialBox"> */}
                        <div className="d-flex align-items-center mb-3">
                            <figure className="mt-0 me-3">
                                <div
                                    className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        fontSize: "22px",
                                    }}
                                >
                                    {initials}
                                </div>
                            </figure>

                            <figcaption className="mb-0">
                                <h5 className="mb-1">{e.testimonial_name}</h5>
                                <small className="text-muted">{e.testimonial_location}</small>

                                <div className="start_rating mt-1">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <i
                                            key={star}
                                            className={
                                                star <= e.testimonial_star
                                                    ? "fa fa-star text-danger"
                                                    : "fa fa-star-o text-danger"
                                            }
                                            aria-hidden="true"
                                        ></i>
                                    ))}
                                </div>
                            </figcaption>
                        </div>

                        <div
                            className="clearfix"
                            dangerouslySetInnerHTML={{ __html: e.testimonial_comment }}
                        />
                    {/* </div> */}
                    </div>
                    </div>
                    </div>
                );
            })}
            

    </Carousel>

{/* <div className="testimonialBox text-center" style={{fontSize: 'x-large'}}>Coming Soon</div> */}



</div>
</section>


        </>
    );
}

export default Testimonials;